module.exports = __webpack_public_path__ + "img/义乌市汇商汽车发展有限公司.63ffb51e.jpg";